import type { AxiosResponse } from 'axios'
import type { IApiResponse } from '@/interfaces/IApiResponse'
import type { IMainToggle } from '@/interfaces/IMainToggle'
import useAxios from '@/composable/useAxios'
import { useGlobalStore } from '@/stores/globalStore'

export const mainToggleApi = {
    get: async (): Promise<IMainToggle> => {
        const mainToggleResponse: AxiosResponse<IApiResponse<IMainToggle>> = await useAxios.get('/v1/main-toggle', {
            noLoading: true,
        })

        const globalStore = useGlobalStore()
        globalStore.setMainToggle(mainToggleResponse.data.data)
        return globalStore.mainToggle
    },
}
